import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import ConsentBanner from "./ConsentBanner";
import { useLocation } from "react-router-dom";
import { initGa4, trackPageView } from "@/lib/ga4";

export default function Layout() {
  const { pathname } = useLocation();
  React.useEffect(() => { initGa4(); }, []);
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackPageView(pathname);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Nav />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ConsentBanner />
    </div>
  );
}
